import getLocal from '@/app/utils/getLocal';
import { useEffect, useState } from 'react';
import { getProductFromGeneralKey, getProductMsg } from '@/utils/productGetServerSideProps';
import { productDetailData } from '@/service';

export interface GeneralKeyItemProps {
    key: string;
    url: string;
}

export default function useProductData() {
    const [data, setData] = useState({ productCatagory: null, productSeries: [], supportDataArr: [] });
    const [gloproductlist, setGloproductlist] = useState([]);
    const { locale } = getLocal();
    const [tryTime, setTryTime] = useState(0);
    const generalKeys: GeneralKeyItemProps[] = [
        { key: 'product_spu_bk626', url: 'streamac' },
        { key: 'product_bk625', url: 'streamacpro' },
        { key: 'product_bk623', url: 'stream' },
    ];
    const generalKeysBak: GeneralKeyItemProps[] = [
        // river 3
        { key: 'product_ps_river_river_705', url: 'river-3-series-portable-power-station' },
        // river 3 plus
        { key: 'product_ps_river_703', url: 'river-3-plus-portable-power-station' },
        // river 3 plus
        { key: 'product_ps_river_703', url: 'river-3-plus-portable-power-station' },
    ];

    useEffect(() => {
        const doAPI = async () => {
            if (typeof window !== 'undefined') {
                try {
                    const fetchResData = await fetch(`${window.location.origin}/api/getappglodata?locale=${locale}`);
                    const fetchRes = await fetchResData.json();
                    if (Array.isArray(fetchRes?.data)) {
                        setGloproductlist(fetchRes?.data);
                    }
                } catch (error) {
                    console.log('error', error);
                }
            }
        };
        if (typeof window !== 'undefined') {
            doAPI();
        }
    }, []);

    useEffect(() => {
        console.log('gloproductlist', gloproductlist);
        const doInit = () => {
            if (gloproductlist?.length > 0 && tryTime < 2) {
                const getProductSeriesData = async () => {
                    const promiseAll = new Set();
                    let proMsgAll: any[] = [];
                    const productPageData: any = {
                        productCatagory: null,
                        productSeries: [],
                        supportDataArr: [],
                    };
                    let len = 0;

                    (tryTime === 0 ? generalKeys : generalKeysBak)?.map((item: GeneralKeyItemProps, _: number) => {
                        const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey: item.key });
                        if (Object.keys(productMsg)?.length > 0) {
                            proMsgAll.push(productMsg);
                            const targetUrl: string = gloproductlist?.find((p: any) => p.generalKey === item.key)?.url || '';
                            promiseAll.add(productDetailData({ handle: targetUrl || item.url }, locale || 'us'));
                            len++;
                            promiseAll.add(getProductMsg(locale, productMsg));
                            len++;
                        }
                    });
                    // promiseAll.add(productFaqBySpuId({ spuId: productMsg?.sourceId }, locale));

                    try {
                        const res: any = await Promise.all(promiseAll);
                        if (proMsgAll?.length > 0 && len > 0 && res) {
                            for (let i = 0; i < len; i++) {
                                const flag1 = res[i] && res[i]?.code === '0';
                                const flag2 = res[i];
                                if (i % 2 === 0) {
                                    if (flag1) {
                                        if (i === 0) {
                                            productPageData.productCatagory = res[i]?.data?.productCatagoryResponseList;
                                        }
                                        productPageData.productSeries.push(res[i]?.data?.spuResponse);
                                    }
                                } else {
                                    if (flag2) {
                                        productPageData.supportDataArr.push({
                                            supportData: res[i]?.supportData,
                                            prodectDetail: proMsgAll[(i - 1) / 2],
                                        });
                                    }
                                }
                            }
                            if (JSON.stringify(productPageData) === JSON.stringify(data)) {
                                setTryTime(tryTime + 1);
                            } else {
                                setData(productPageData);
                            }
                        }
                    } catch (e: any) {
                        console.error('error', e);
                    }
                };

                getProductSeriesData();
            }
        };
        doInit();
    }, [gloproductlist]);

    return { data };
}
